package strings

import io.github.skeptick.libres.strings.PluralForms
import io.github.skeptick.libres.strings.getCurrentLanguageCode
import kotlin.String

public object StringsEn : Strings {
  override val home: String = "Home"

  override val about: String = "About"

  override val contact: String = "Contact"

  override val book_stands: String = "Book stand"

  override val search: String = "Search"

  override val create_library: String = "Create library"

  override val footer_author: String = "Copyright 2025 dev0029"

  override val section1_title: String = "Special days packaging"

  override val section1_button: String = "More info"

  override val section1_desc: String =
      "For special days; such as Mother's Day, Christmas, Valentine's Day we carefully package your orders."

  override val section2_title: String = "Bedside book stands"

  override val section2_button: String = "Order now"

  override val section2_desc: String =
      "Are you looking for a book holder while you are reading your favorite book at bed? "

  override val section3_title: String = "Create miniature library"

  override val section3_button: String = "Create now"

  override val section3_desc: String =
      "What is your favorite books, create a collection of your favorite book list and let use to produce your miniature library!"

  override val shipping_title: String = "Shipping"

  override val shipping_desc1: String = "Fast and free shipping"

  override val shipping_description: String =
      "With our express delivery service, your items will arrive at your doorstep within 2-4 business days. We proudly ship to the following U.S. states: Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina, North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina, South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia, Wisconsin, and Wyoming."

  override val shipping_description2: String =
      "Additionally, we ship to Canada, UK and all EU countries, ensuring a seamless shopping experience for all our customers in North America."

  override val contact_title: String = "Contact us"

  override val contact_email_name: String = "Your name"

  override val contact_email_subject: String = "Subject"

  override val contact_email_message: String = "Message"

  override val contact_email_send_message: String = "Send message"

  override val library_header_title: String = "Create your library"

  override val library_header_title2: String = "Your book list created, now it is time to order!"

  override val library_header_desc: String = "*Order of books not important"

  override val library_header_desc2: String =
      "Click order button and paste your unique to \"Personalization\" section at Etsy."

  override val copy_your_id: String = "Copy your unique book list id:"

  override val download_book_list: String = "Download book list"

  override val ok: String = "Ok"

  override val remove: String = "Remove"

  override val search_author: String = "Search author"

  override val result_found: String = "result found"

  override val loading: String = "Loading:"

  override val not_load: String = "Model not loaded"
}
